<template>
  <v-textarea
    class="topsearch"
    v-model="localValue"
    counter
    :label="label || ''"
    :placeholder="placeholder || ''"
    :maxlength="maxlength || 500"
    density="compact"
    variant="outlined"
    rows="3"
    hide-details="auto"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>
<script>
export default {
  name: "TextArea",
  props: {
    modelValue:  { default: null },
    label:       { type: String, default: "" },
    placeholder: { type: String, default: "" },
    maxlength:   { type: Number, default: 500 },
  },
  emits: ["update:modelValue"],
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.$emit("update:modelValue", val); },
    },
  },
};
</script>